import Dialog from "../dialog/dialog";
import Select from "react-select";

import React, { useState } from "react";

/**
 * This component renders dialog box taking user's confirmation if he wants to make a phone call.
 * @param {Object} props
 * @param {Boolean} props.show show or hide dialog box
 * @param {Function} props.onHide callback function which is called when no is pressed
 * @param {String} props.phoneNumber number on which user wants to send SMS
 * @param {Boolean} props.isActive true if logged in user has a zoom phone number
 */

const SmsDialog = ({ show, onHide, phoneNumber, isActive }) => {
  const formattedPhoneNumber = phoneNumber.replace(/\D/g, "");

  const dialogBody = (
    <a href={`zoomphonesms://${formattedPhoneNumber}`} className="modal-link">
      SMS
    </a>
  );

  return (
    <Dialog
      show={show}
      onHide={onHide}
      title="SMS Confirmation"
      body={`Do you want to send an SMS to the phone number ${formattedPhoneNumber}?`}
      click={onHide}
      clickname={isActive ? dialogBody : "SMS"}
      closename="CANCEL"
    />
  );
};

export default SmsDialog;
